import { render, staticRenderFns } from "./SettingPay.vue?vue&type=template&id=ef87723a&"
import script from "./SettingPay.vue?vue&type=script&lang=js&"
export * from "./SettingPay.vue?vue&type=script&lang=js&"
import style0 from "./SettingPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingPay.vue"
export default component.exports